import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "variant"
};
const _hoisted_2 = { class: "data-item__section variant__header" };
const _hoisted_3 = { class: "data-item__section-title" };
const _hoisted_4 = { class: "variant__sku" };
const _hoisted_5 = { class: "data-item__section product__section" };
const _hoisted_6 = {
    key: 0,
    class: "product__images"
};
const _hoisted_7 = { class: "product__attributes" };
const _hoisted_8 = { class: "columns" };
const _hoisted_9 = { class: "column" };
const _hoisted_10 = { class: "column" };
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = { class: "data-item__section product__section" };
const _hoisted_13 = {
    key: 0,
    class: "data-item__section product__section product__section--assets"
};
const _hoisted_14 = { class: "product__attributes" };
const _hoisted_15 = { class: "data-item__section product__section product__section--associations" };
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from "vue-router";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import ProductUtils from "@astina/paloma-shop-common-ui/src/services/ProductUtils";
import ProductAttributes from "@astina/paloma-shop-common-ui/src/components/ProductAttributes.vue";
import ProductAssets from "@astina/paloma-shop-common-ui/src//components/ProductAssets.vue";
import ProductImages from "../components/ProductImages.vue";
import ProductPackagingUnits from "@astina/paloma-shop-common-ui/src/components/ProductPackagingUnits.vue";
import ProductPastOrders from "../components/ProductPastOrders.vue";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
import config from "../services/PortalConfig";
import ProductVariantDeliveryDays from "../components/ProductVariantDeliveryDays.vue";
import ProductAssociations from "../components/ProductAssociations.vue";
import ProductAttributeGroup from "@astina/paloma-shop-common-ui/src/components/ProductAttributeGroup.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductVariantView',
    props: {
        product: {}
    },
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const props = __props;
        const variant = ref(null);
        const attributes = ref([]);
        const displayProductUnits = ref(config.displayProductUnits);
        const displayContainedUnits = ref(config.displayContainedUnits);
        const displayProductUnitMsrp = ref(config.displayProductUnitMsrp);
        const showPriceUnavailableAltText = ref(config.showPriceUnavailableAltText);
        const showPastOrders = ref(config.productShowPastOrders);
        const productDescription = computed(() => {
            const property = config.productDetails.descriptionProperty;
            return props[property || 'description'] || null;
        });
        const images = computed(() => {
            return variant.value?.images.length === 0
                ? props.product.master.images
                : variant.value.images;
        });
        const assets = computed(() => {
            return variant.value?.assets.length === 0
                ? props.product.master.assets
                : variant.value.assets;
        });
        onMounted(init);
        watch(() => route.params, reset);
        function reset() {
            RouterUtils.singleParam(route, 'sku') !== variant.value?.sku && init();
        }
        function init() {
            const sku = RouterUtils.singleParam(route, 'sku');
            const variantLocal = props.product.variants.find(v => v.sku === sku);
            if (!variantLocal || props.product.variants.length === 1) {
                router.push({ name: 'catalog_category_product', params: { id: props.product.itemNumber } });
                return;
            }
            variant.value = variantLocal;
            attributes.value = ProductUtils.createAttributes(variant.value);
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (variant.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("section", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_router_link, {
                                to: { name: 'catalog_category_product_details', params: { id: __props.product.itemNumber } },
                                class: "variant__close"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(Icon, {
                                        name: "times",
                                        "icon-style": "light"
                                    })
                                ]),
                                _: 1
                            }, 8, ["to"]),
                            _createTextVNode(" " + _toDisplayString(variant.value.name) + " ", 1),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(variant.value.sku), 1)
                        ])
                    ]),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_5, [
                        (images.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createVNode(ProductImages, { images: images.value }, null, 8, ["images"])
                            ]))
                            : _createCommentVNode("", true),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createVNode(ProductAttributeGroup, {
                                        group: "general",
                                        product: __props.product,
                                        variant: variant.value,
                                        "hide-title": true,
                                        "no-prop-borders": true
                                    }, null, 8, ["product", "variant"]),
                                    _cache[0] || (_cache[0] = _createTextVNode()),
                                    _createVNode(ProductAttributeGroup, {
                                        group: "codes",
                                        product: __props.product,
                                        variant: variant.value,
                                        "hide-title": true,
                                        "no-prop-borders": true
                                    }, null, 8, ["product", "variant"])
                                ]),
                                _cache[1] || (_cache[1] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_10, [
                                    (showPastOrders.value)
                                        ? (_openBlock(), _createBlock(ProductPastOrders, {
                                            key: 0,
                                            product: __props.product
                                        }, null, 8, ["product"]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            _createVNode(ProductPackagingUnits, {
                                variant: variant.value,
                                displayProductUnits: displayProductUnits.value,
                                "display-contained-units": displayContainedUnits.value,
                                "display-msrp": displayProductUnitMsrp.value,
                                showPriceUnavailableAltText: showPriceUnavailableAltText.value
                            }, null, 8, ["variant", "displayProductUnits", "display-contained-units", "display-msrp", "showPriceUnavailableAltText"]),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            (_unref(config).productDetails.displayDeliveryDays)
                                ? (_openBlock(), _createBlock(ProductVariantDeliveryDays, {
                                    key: 0,
                                    "item-number": __props.product.itemNumber,
                                    variant: variant.value
                                }, null, 8, ["item-number", "variant"]))
                                : _createCommentVNode("", true),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            (productDescription.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    innerHTML: productDescription.value,
                                    class: "product__description"
                                }, null, 8, _hoisted_11))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    _createElementVNode("section", _hoisted_12, [
                        _createVNode(ProductAttributes, {
                            product: __props.product,
                            variant: variant.value,
                            "exclude-groups": ['default', 'general', 'codes']
                        }, null, 8, ["product", "variant"])
                    ]),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    (assets.value.length > 0)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(ProductAssets, {
                                    style: { "padding-top": "0", "margin-top": "0" },
                                    assets: assets.value
                                }, null, 8, ["assets"])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _cache[9] || (_cache[9] = _createTextVNode()),
                    _createElementVNode("section", _hoisted_15, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['recommended', 'similar', 'successor', 'predecessor'], (assoc) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (__props.product.associations[assoc] && __props.product.associations[assoc].length > 0)
                                    ? (_openBlock(), _createBlock(ProductAssociations, {
                                        association: assoc,
                                        "item-numbers": __props.product.associations[assoc],
                                        key: assoc
                                    }, null, 8, ["association", "item-numbers"]))
                                    : _createCommentVNode("", true)
                            ], 64));
                        }), 64))
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
